import * as yup from 'yup';

import { requiredString } from '../../../common/validation/yupUtils';

export const equipmentSchema = yup.object().shape({
  make: requiredString,
  model: requiredString,
});
